import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./rich-text-editor.css";

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "link"],
        ["clean"],
    ],
};

export default function RichTextEditor({ value, onChange, placeholder, readOnly = false }) {
    return (
        <div className="perx-quill">
            <ReactQuill
                theme="snow"
                value={value || ""}
                onChange={onChange}
                modules={modules}
                readOnly={readOnly}
                placeholder={placeholder}
            />
        </div>
    );
}
